// extracted by mini-css-extract-plugin
module.exports = {"icon":"BTb8W","reversedIcon":"_2K9Aj","overflow":"_3Pg00","title":"_3QSgT","mobile":"_3K6Ur","listContentTitleColor":"dIHhK"};